import React, { useContext } from 'react';
import "./style.scss";
import { FlowDetailsContext } from '../../../../../../../../providers/flowDetails-provider';
import { amountFormatter } from '../../../../../../../../utils';


const FlowDetails = () => {

    const { flowDetails } = useContext(FlowDetailsContext);

    const totalAmount = amountFormatter(flowDetails?.flowData?.totalAmount);
    // const totalAmount = flowDetails?.flowData?.totalAmount;

    return (
        <div className='loan-details'>
            {
                flowDetails && flowDetails?.flowData ? (
                    <div className='loan-details__items'>
                        <h1>{flowDetails?.flowData?.flowName}</h1>
                        <h1 className='loan-details__items__total-applications'><span>#</span>{flowDetails?.flowData?.totalApplications}</h1>
                        <h1 className='loan-details__items__amount'><span>₹</span>{totalAmount}</h1>
                    </div>
                ) : null
            }

        </div>
    )
}

export default FlowDetails;
